import { render } from "./layouts-header.vue?vue&type=template&id=6c406378&scoped=true"
import script from "./layouts-header.vue?vue&type=script&lang=js"
export * from "./layouts-header.vue?vue&type=script&lang=js"

import "./layouts-header.vue?vue&type=style&index=0&id=6c406378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c406378"]])

export default __exports__